import mutations from './eprofileTerapia.mutations'
import actions from './eprofileTerapia.actions'
import getters from './eprofileTerapia.getters'

import initialState from './defaultState'

const state = initialState();

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}
